import { swSettings } from "app/common/services/swSettings";
import { translate } from "app/filters/i18nFilter";
import { MenuItemType } from "app/pages/digital-marketing/generative-ai/llm-tracker/homepage/types";
import { isCampaignCompleted } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/LLMTrackerUtils";
import type { IAiTrackerCampaign } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";
import { isWeeklyReportSubscribed } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

import type { IMenuItem } from "./types";

interface IMenuItemsConfig {
    canEdit?: boolean;
    canDelete?: boolean;
    campaign?: IAiTrackerCampaign;
    isSubscribePending?: boolean;
}

export const getMenuItems = (config: IMenuItemsConfig = {}): Record<MenuItemType, IMenuItem> => {
    const { canEdit = false, canDelete = false, campaign, isSubscribePending = false } = config;

    const isCompleted = isCampaignCompleted(campaign);
    const isSubscribed = isWeeklyReportSubscribed(campaign?.subscriptions);

    return {
        [MenuItemType.Edit]: {
            text: canEdit
                ? translate("llmTracker.campaignQuery.edit.menu-item")
                : translate("llmTracker.campaignQuery.settings.menu-item"),
            icon: canEdit ? "edit" : "info",
            isEnabled: isCompleted,
        },
        [MenuItemType.Subscribe]: {
            text: isSubscribed ? translate("llmTracker.menu.unsubscribe") : translate("llmTracker.menu.subscribe"),
            icon: "email",
            isEnabled: isCompleted && !isSubscribePending && !campaign?.isDemo,
        },
        [MenuItemType.Delete]: {
            text: translate("global.delete"),
            icon: "delete",
            isEnabled: canDelete && swSettings.components.AiTracker.resources.AIBrandTrackerCampaignDeletion,
        },
    };
};
